import { render } from "./LoadingLogo.vue?vue&type=template&id=12b37c1e"
const script = {}

import "./LoadingLogo.vue?vue&type=style&index=0&id=12b37c1e&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__